import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Update Contact Information")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-4" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Enter the information you wish to update in the applicable field. These changes automatically update your account. ")
], -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "col-md-12 mb-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Phone Number", -1)
const _hoisted_7 = {
  id: "phoneContainer",
  class: "mb-4"
}
const _hoisted_8 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_9 = {
  key: 2,
  class: "col-md-12"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", null, "Web Email Address", -1)
const _hoisted_11 = { class: "form-group row mb-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary col-md-2"
}, /*#__PURE__*/_toDisplayString(('Back')), -1)
const _hoisted_13 = {
  type: "submit",
  class: "btn btn-primary col-md-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_PhoneNumber = _resolveComponent("PhoneNumber")!
  const _component_WebEmail = _resolveComponent("WebEmail")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Alerts, {
      errors: $setup.errors,
      success: $setup.success
    }, null, 8, ["errors", "success"]),
    _hoisted_2,
    _hoisted_3,
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Loading..."))
      : (_openBlock(), _createElementBlock("form", {
          key: 1,
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleSubmit && $setup.handleSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.phones, (phone) => {
                return (_openBlock(), _createBlock(_component_PhoneNumber, {
                  key: phone.CMIID,
                  phone: phone,
                  phoneTypes: $setup.phoneTypes,
                  selectedPrimary: $setup.selectedPrimary,
                  onUpdateData: $setup.updateData,
                  onDeletePhone: $setup.deletePhone
                }, null, 8, ["phone", "phoneTypes", "selectedPrimary", "onUpdateData", "onDeletePhone"]))
              }), 128))
            ]),
            ($setup.showNewPhoneTemplate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(), _createBlock(_component_PhoneNumber, {
                    key: 'newPhoneTemplate',
                    phone: $setup.newPhone,
                    phoneTypes: $setup.phoneTypes,
                    selectedPrimary: $setup.selectedPrimary,
                    onUpdateData: $setup.updateData,
                    "is-new": ""
                  }, null, 8, ["phone", "phoneTypes", "selectedPrimary", "onUpdateData"]))
                ]))
              : _createCommentVNode("", true),
            (!$setup.showNewPhoneTemplate)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn btn-primary mb-4",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.addPhone && $setup.addPhone(...args)))
                }, " + Add another phone number"))
              : _createCommentVNode("", true),
            ($setup.emails)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.emails, (email) => {
                    return (_openBlock(), _createBlock(_component_WebEmail, {
                      key: email.CMIID,
                      email: email,
                      onUpdateData: $setup.updateData
                    }, null, 8, ["email", "onUpdateData"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: { name: 'profile' },
                class: "col-md-8"
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }),
              _createElementVNode("button", _hoisted_13, _toDisplayString($setup.loadingSubmit ? 'Submitting...' : 'Update Information'), 1)
            ])
          ])
        ], 32))
  ]))
}